import React from 'react';

import type { CourseCardProps } from 'Components/Card/Course';
import type { GeneralPromoPointProps } from 'Modules/PromoPoint/General';
import type { CourseListingClearingCardProps } from 'Campaigns/Clearing/Card/CourseListing';

import Main from 'Elements/Main';
import Section from 'Elements/Section';

import Grid, { Col } from 'Components/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';

import CourseListingHeroBanner, {
    CourseListingHeroBannerProps
} from 'Modules/HeroBanner/CourseListing';
import CourseListingModule from 'Modules/Listing/Course';
import CourseListingFilters, { CourseListingFiltersProps } from 'Modules/Filters/CourseListing';
import CourseCompare from 'Modules/CourseCompare';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    heroBanner: CourseListingHeroBannerProps;
    filters: CourseListingFiltersProps;
    courses: {
        items: (CourseCardProps & { id: string })[];
        totalCount: number;
        pageSize: number;
        pageIndex: number;
    };
    promoCards: GeneralPromoPointProps | CourseListingClearingCardProps;
}

const Landing: React.FC<Props> = props => {
    const { breadcrumbs, heroBanner, courses, promoCards, filters } = props;

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <CourseListingHeroBanner {...heroBanner} />
            <CourseListingFilters {...filters} />
            <Section id="listing" padding="none" background>
                <Grid>
                    <Col xl={[2, 11]}>
                        <CourseListingModule
                            results={courses.items}
                            pagination={{
                                id: 'courses-listing-pagination',
                                totalCount: courses.totalCount,
                                pageSize: courses.pageSize,
                                initialPageIndex: courses.pageIndex
                            }}
                            promoCard={promoCards}
                        />
                    </Col>
                </Grid>
            </Section>
            <CourseCompare />
        </Main>
    );
};

export default Landing;
